import { NgModule } from '@angular/core';
import { SummaryTableComponent } from "./components/summary-table/summary-table.component";
import { SmartpowerComponent } from "./smartpower.component";
import {
  FssDirective,
  OperationDirective,
  PerformanceDetailTableComponent
} from "./components/performance-detail-table/performance-detail-table.component";
import { EbrCoreModule } from "../../core/components/ebr-core.module";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "../../app-routing.module";
import { MatButtonModule } from '@angular/material/button';
import { LocationsTableComponent } from './components/locations-table/locations-table.component';
import {MatSelectModule} from "@angular/material/select";


@NgModule({
  declarations: [
    PerformanceDetailTableComponent,
    SummaryTableComponent,
    SmartpowerComponent,
    OperationDirective,
    FssDirective,
    LocationsTableComponent
  ],
    imports: [
        EbrCoreModule,
        BrowserModule,
        AppRoutingModule,
        MatButtonModule,
        MatSelectModule,
    ],
  exports: [
    SmartpowerComponent
  ],
  providers: [],
  bootstrap: []
})
export class SmartpowerModule {}
